import React from 'react';
import Spin from 'm-ui/es/spin';
import 'm-ui/es/spin/style/index';

const Loading: React.FC = () => {
  return (
    <div style={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Spin size="large" />
    </div>
  );
};

export default Loading;
